import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	enablePriceDisclaimer: true,
	financeDomain: 'AUDI.PL',
	nextBestActions: [
		{
			description: 'Samochody gotowe do odbioru',
			icon: '',
			labelText: 'Samochody gotowe do odbioru',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.pl/pl/web/pl/wyszukiwarka-samochodow-nowych.html#filter=carline.{{carlineId}}',
		},
		{
			description: 'Zapisz się na jazdę testową',
			icon: 'test-drive',
			labelText: 'Zapisz się na jazdę testową',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://www.audi.pl/pl/web/pl/modele/layer/jazda-testowa.html',
		},
		{
			description: 'Ładowanie w drodze',
			icon: 'wallbox',
			labelText: 'Ładowanie w drodze',
			target: '_blank',
			trackingName: '',
			url: 'https://www.audi.pl/pl/web/pl/strefa-klienta/elektromobilnosc/audi-charging.html',
		},
		{
			description: 'Konsultacja online z Audi Ekspert',
			icon: 'hotline',
			labelText: 'Konsultacja online z Audi Ekspert',
			target: '_blank',
			trackingName: 'poa link',
			url: 'https://www.audi.pl/pl/web/pl/strefa-klienta/audi-ekspert-online.html',
		},
	],
	summaryFooterCta: {
		description: 'Wyślij konfigurację do dealera',
		icon: 'send',
		labelText: 'Wyślij konfigurację do dealera',
		target: '_blank',
		trackingName: 'contact',
		url: 'https://formularz.audi.pl/wyslij-konfiguracje-do-dealera/?carline={{carlineId}}&audicode={{audiCode}}&model_year={{modelYear}}&conf_desc=quattro',
	},
};
